import React, { useState, useEffect } from 'react';
import {
    Typography,
    Button,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Checkbox,
    IconButton,
    Grid,
    Box,
    Dialog,
    DialogTitle,
    DialogActions,
    Select,
    MenuItem,
    Card,
    CardContent,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CreateArticle from '../../components/CreateArticle/CreateArticle';
import EditArticle from '../../components/EditArticle/EditArticle';
import api from '../../services/api';
import { formatDate, formatDateWithHour } from '../../utils/dateFormat';
import { Check } from '@mui/icons-material';
import SyncNews from './SyncNews';
import Multiple from '../../components/Multiple';
import ReleasesAnalitics from '../../components/ReleasesAnalitics/ReleasesAnalitics';
import OrederBy from '../../components/Orderby/OrderBy';

export interface Notice {
    id: number;
    type: string;
    title: string;
    content: string;
    notification: boolean;
    send_at: string;
    created_at: string;
    modified_at: string;
    createdAt: string;
    updatedAt: string;
    date: string;
    views: {
        total: number,
        totalNotRead: number,
        usersRead: any[]
    }
}

interface Paginate {
    has_more: boolean;
    itemCount: number;
    pageCount: number;
}

const Releases = () => {
    const [rows, setRows] = useState<Notice[]>([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(-1);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
    });
    const [currentPage, setCurrentPage] = useState(1);

    const [sortColumn, setSortColumn] = useState<string>('');
    const [sortType, setSortType] = useState<string>('');
    const [clearSort, setclearSort] = useState(0);

    // multiple selected by checkbox ids in string
    const [multiple, setMultiple] = useState<number[]>([]);

    useEffect(() => {
        // Fetch the initial user list
        fetchPost();
    }, [pagination.page, pagination.limit]); // Add pagination.page to the dependency array
    useEffect(() => {
        fetchPost()
    }, [sortColumn, sortType])

    const fetchPost = async () => {
        try {

            let orderQuery = {}
            if (sortColumn && sortType) {
                orderQuery = {
                    order: [sortColumn, sortType]
                }

            }

            const response = await api.post(`/v1/post/list?limit=${pagination.limit}&page=${pagination.page}`, {
                ...orderQuery
            });
            const { posts, paginate } = response.data;
            setRows(posts);
            setPagination((prevPagination) => ({
                ...prevPagination,
                total: response.data.paginate.pageCount,
            }));
        } catch (error) {
            console.error('Failed to fetch posts', error);
        }
    };

    const clearSortEmit = () => {
        setclearSort(Date.now())
    }

    const handleDelete = async () => {
        try {
            if (multiple.length > 0) {
                await Promise.all(
                    multiple.map(async (id) => {
                        await api.delete(`/v1/notice/del/${id}`);
                    })
                );
            } else {
                await api.delete(`/v1/notice/del/${deleteItemId}`);
            }

            fetchPost();
            setDeleteItemId(-1);
            closeDialog();
        } catch (error) {
            console.error('Failed to delete notice', error);
        }
    };

    const handlePaginationChange = (page: number) => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            page: page,
        }));
    };

    const openDialog = () => setDialogOpen(true);
    const closeDialog = () => setDialogOpen(false);

    const goToPage = (page: number) => {
        setCurrentPage(page);
    };

    const handleCheckMultiple = (e: any, id: number) => {
        let newMultiple = [...multiple];
        if (e.target.checked) {
            newMultiple.push(id);
        } else {
            const index = newMultiple.findIndex((idItem) => idItem === id);
            if (index !== -1) {
                newMultiple.splice(index, 1);
            }
        }
        setMultiple(newMultiple);
    };


    const handleResultsPerPageChange = (event: any) => {
        const resultsPerPage = parseInt(event.target.value);
        setPagination((prevPagination) => ({
            ...prevPagination,
            limit: resultsPerPage
        }));
    };

    const handleCheckAll = (selectAll: boolean) => {
        let newSelected: number[] = [];
        if (selectAll) {
            rows.forEach((rowItem) => {
                newSelected.push(rowItem.id);
            });
        }
        setMultiple(newSelected);
    };


    const handleSortClick = (column: string, type: string) => {
        setSortColumn(column);
        setSortType(type);
    }

    return (
        <>
            <Grid item xs={12}>
                <SyncNews refreshNews={fetchPost} />
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <TableContainer>
                                <Table size="small" className='table-center'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <OrederBy
                                                    label="Título"
                                                    sortLabel="title"
                                                    clearSortEmit={clearSortEmit}
                                                    sortColumn={sortColumn}
                                                    sortType={sortType}
                                                    onSort={handleSortClick}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <OrederBy
                                                    label="Vísto"
                                                    sortLabel="views"
                                                    clearSortEmit={clearSortEmit}
                                                    sortColumn={sortColumn}
                                                    sortType={sortType}
                                                    onSort={handleSortClick}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <OrederBy
                                                    label="Publicado"
                                                    sortLabel="date"
                                                    clearSortEmit={clearSortEmit}
                                                    sortColumn={sortColumn}
                                                    sortType={sortType}
                                                    onSort={handleSortClick}
                                                />
                                            </TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <TableRow key={row.id}>
                                                <TableCell>{row.title}</TableCell>
                                                <TableCell>{row.views.total}</TableCell>
                                                <TableCell style={{ width: "200px" }}>
                                                    {formatDateWithHour(row.date)}
                                                </TableCell>
                                                <TableCell>
                                                    <ReleasesAnalitics
                                                        buttonTitle="Estadísticas"
                                                        total={row.views?.total}
                                                        totalNotRead={row.views?.totalNotRead}
                                                        usersRead={row.views?.usersRead}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end" marginTop={2}>
                    <Button
                        disabled={pagination.page === 1}
                        onClick={() => handlePaginationChange(pagination.page - 1)}
                    >
                        Anterior
                    </Button>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "12px"
                    }}>
                        Página {pagination.page} de {pagination.total}
                    </Box>
                    <Button
                        disabled={pagination.page === (pagination.total)}
                        onClick={() => handlePaginationChange(pagination.page + 1)}
                    >
                        Siguiente
                    </Button>
                    <Select
                        value={pagination.limit} // Valor inicial del número de resultados por página
                        onChange={handleResultsPerPageChange}
                        style={{ marginLeft: '8px' }}
                    >
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={15}>15</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                    </Select>
                </Box>
            </Grid>

            <Dialog
                open={dialogOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">¿Realmente deseas eliminar este comunicado?</DialogTitle>

                <DialogActions>
                    <Button
                        onClick={() => {
                            setDeleteItemId(-1);
                            closeDialog();
                        }}
                        autoFocus
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => {
                            handleDelete();
                            closeDialog();
                        }}
                        autoFocus
                    >
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Releases;
